import app from '@/AppData'

const ENV = require('@/env.js')

// 所有与客户端相关的接口，新产品接入时需要适配

function getUserSetting (refresh) {
  return new Promise((resolve, reject) => {
    if (!app.getData().userSetting || refresh || !app.getData().userSettingReady) {
      if (ENV.MOCK) {
        const result = {
          'platformType': 3,
          'phoneNum': '18620058240',
          'switchState': 7,
          'voiceRole': 0,
          'openSuccess': true,
          'outsideReminder': true,
          'sendMsgNotify': false,
          'newServingNum': '',
          'servingNumInvalid': false
        }
        resolve(result)
      } else {
        _authReq({
          name: 'userAiPhoneInfo',
          method: 'post'
        }).then(res => {
          console.log('getUserSetting', res, JSON.stringify(res.data.data))
          if (res.data.success) {
            if (app.getData().userSetting.phoneNum && res.data.data.phoneNum === '') {
              resolve(app.getData().userSetting)
            } else {
              resolve(res.data.data)
            }
          } else {
            resolve(app.getData().userSetting)
          }
        }).catch(err => {
          console.log('getUserSetting', 'err', err)
        })
      }
    }
    if (app.getData().userSettingReady && app.getData().userSetting && !refresh) resolve(app.getData().userSetting)
  })
}

function getCalledList (startTime) {
  if (ENV.MOCK) {
    return new Promise((resolve, reject) => {
      const data = {
        code: 0,
        success: true,
        msg: '',
        data: {
          resp: {
            result: 0,
            isFinished: true,
            recordList: [{
              callKey: {
                sessionId: 'bf9f2c819f05597ef7ed7bfaa2b3a678',
                callerPhoneNum: '02131766985',
                calledPhoneNum: '18620058240'
              },
              startTime: 1600911207,
              endTime: 1600911252,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month9/000-3264667145-12361-aa8789d1a845402082dab7d4aee5ac0f-000-1600911207.mp3',
              chatList: [{time: 1600911207, callerText: '', respText: '喂，您好，请问您是哪位？'}, {
                time: 1600911224,
                callerText: '最近金如果上传身份证以上的页面，单位完成上传是否遇到了什么问题呢？需要花半分钟给您介绍一下流程吗？',
                respText: '嗯好，有什么具体的事可以告诉我，我可以帮您转达。'
              }, {
                time: 1600911244,
                callerText: '您需要再入金所APP我的账户月中进入账户升级，这栏点击上传证件照，按提示上传您身份证件的正反面，使用清晰无遮挡的以上才能通过。',
                respText: '嗯好，我已经记录下来，还有什么事？'
              }],
              calledCountOnWeek: 2,
              endTimeOnWeek: 1601346430,
              intention: '',
              refineInfo: '',
              startTimeText: '09月24日 09:33',
              endTimeText: '09月24日 09:34',
              firstMsg: '最近金如果上传身份证以上的页面，单位完成上传是否遇到了什么问题呢？需要花半分钟给您介绍一下流程吗？',
              readStatus: 0
            }, {
              callKey: {
                sessionId: 'b58ed0fb7005f6a7375f42ba9fc16224',
                callerPhoneNum: '02095736408',
                calledPhoneNum: '18620058240'
              },
              startTime: 1600849920,
              endTime: 1600849927,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month9/000-3711798281-12361-7a2e9dcdbaab44b6898372ba403fe5fe-000-1600849920.mp3',
              chatList: [{time: 1600849921, callerText: '', respText: '喂，您好，请问您是哪位？'}],
              calledCountOnWeek: 1,
              endTimeOnWeek: 1601346430,
              intention: '',
              refineInfo: '',
              startTimeText: '09月23日 16:32',
              endTimeText: '09月23日 16:32',
              firstMsg: '',
              readStatus: 0
            }, {
              callKey: {
                sessionId: '9ea24c15684e178718979721249dfd61',
                callerPhoneNum: '02095249502',
                calledPhoneNum: '18620058240'
              },
              startTime: 1600398983,
              endTime: 1600398993,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month9/000-3124595721-12367-03af20f697014146bd761ec79bdae913-000-1600398983.mp3',
              chatList: [{time: 1600398984, callerText: '', respText: '喂，您好，请问您是哪位？'}],
              calledCountOnWeek: 3,
              endTimeOnWeek: 1600741630,
              intention: '',
              refineInfo: '',
              startTimeText: '09月18日 11:16',
              endTimeText: '09月18日 11:16',
              firstMsg: '',
              readStatus: 0
            }, {
              callKey: {
                sessionId: '23905b0cadf1f52fc5bf8e4ee03b8ecc',
                callerPhoneNum: '13751189610',
                calledPhoneNum: '18620058240'
              },
              startTime: 1600352584,
              endTime: 1600352588,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month9/000-3124595721-12362-dbce1113ea1647e5a6c94bcacfa4e090-000-1600352583.mp3',
              chatList: [{time: 1600352584, callerText: '', respText: '喂，您好，请问您是哪位？'}],
              calledCountOnWeek: 2,
              endTimeOnWeek: 1600741630,
              intention: '',
              refineInfo: '',
              startTimeText: '09月17日 22:23',
              endTimeText: '09月17日 22:23',
              firstMsg: '',
              readStatus: 0
            }, {
              callKey: {
                sessionId: 'b3ebdc58bbd755e565dd6b970537fa6f',
                callerPhoneNum: '02066249040',
                calledPhoneNum: '18620058240'
              },
              startTime: 1600350584,
              endTime: 1600350595,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month9/000-2839514121-12365-9e105ebd213e47c0b60cd9af34fc2f8e-000-1600350584.mp3',
              chatList: [{time: 1600350585, callerText: '', respText: '喂，您好，请问您是哪位？'}],
              calledCountOnWeek: 1,
              endTimeOnWeek: 1600741630,
              intention: '',
              refineInfo: '',
              startTimeText: '09月17日 21:49',
              endTimeText: '09月17日 21:49',
              firstMsg: '',
              readStatus: 0
            }, {
              callKey: {
                sessionId: 'e31dfee3fed9d5584f8a94e50d945f34',
                callerPhoneNum: '18620058240',
                calledPhoneNum: '18620058240'
              },
              startTime: 1600161232,
              endTime: 1600161259,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month9/000-893357065-12365-292f7b1b28844422b24622cf19424ba1-000-1600161232.mp3',
              chatList: [{time: 1600161233, callerText: '', respText: '喂，您好，请问您是哪位？'}, {
                time: 1600161246,
                callerText: '喂喂。',
                respText: '嗯好，有什么具体的事可以告诉我，我可以帮您转达。'
              }, {time: 1600161249, callerText: '你在听我说话。', respText: '好嘞，我已经记录下来，还有其他事吗？'}, {
                time: 1600161254,
                callerText: '啊。',
                respText: '好嘞，您的来意我立马帮您转达，祝您生活愉快，再见。'
              }],
              calledCountOnWeek: 0,
              endTimeOnWeek: 0,
              intention: '通用对话',
              refineInfo: '通用对话',
              startTimeText: '09月15日 17:13',
              endTimeText: '09月15日 17:14',
              firstMsg: '喂喂。',
              readStatus: 1
            }, {
              callKey: {
                sessionId: '12d966df609e11e8160a28faf6b2b421',
                callerPhoneNum: '17017375493',
                calledPhoneNum: '18620058240'
              },
              startTime: 1599640266,
              endTime: 1599640271,
              recordUrl: '',
              chatList: [{time: 1599640266, callerText: '', respText: '喂，您好，请问您是哪位？'}],
              calledCountOnWeek: 3,
              endTimeOnWeek: 1600136830,
              intention: '',
              refineInfo: '',
              startTimeText: '09月09日 16:31',
              endTimeText: '09月09日 16:31',
              firstMsg: '',
              readStatus: 0
            }, {
              callKey: {
                sessionId: '3a2e2b8ec2cc4056b19affb6d8949c3c',
                callerPhoneNum: '02010108819',
                calledPhoneNum: '18620058240'
              },
              startTime: 1599557352,
              endTime: 1599557361,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month9/000-3007286281-12361-e188cb0d94854b0987113f76f2ba4174-000-1599557352.mp3',
              chatList: [{time: 1599557353, callerText: '', respText: '喂，您好，请问您是哪位？'}],
              calledCountOnWeek: 2,
              endTimeOnWeek: 1600136830,
              intention: '',
              refineInfo: '',
              startTimeText: '09月08日 17:29',
              endTimeText: '09月08日 17:29',
              firstMsg: '',
              readStatus: 1
            }, {
              callKey: {
                sessionId: 'ec7c5030713eff4367bfe8bd72efd342',
                callerPhoneNum: '02095299175',
                calledPhoneNum: '18620058240'
              },
              startTime: 1599278064,
              endTime: 1599278107,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month9/000-3124595721-12361-d0206532a9244599828535cc942a8a34-000-1599278064.mp3',
              chatList: [{time: 1599278065, callerText: '', respText: '喂，您好，请问您是哪位？'}, {
                time: 1599278081,
                callerText: '交界平洲公园地铁上盖物业，全新开盘，总价25万，绝版六米，复式带精装修，想邀请您过来参观了解一下。',
                respText: '小区具体是在哪个位置呢？'
              }, {
                time: 1599278095,
                callerText: '我们楼盘是在广佛交界，平洲公园地铁上盖五分钟直达荔湾西朗人流，地理位置非常好，您知道吗？',
                respText: '房子的面积有多大？'
              }, {time: 1599278103, callerText: '喂，你好喂，你好。', respText: '价格上有什么优惠吗？'}],
              calledCountOnWeek: 2,
              endTimeOnWeek: 1599532030,
              intention: '',
              refineInfo: '',
              startTimeText: '09月05日 11:54',
              endTimeText: '09月05日 11:55',
              firstMsg: '交界平洲公园地铁上盖物业，全新开盘，总价25万，绝版六米，复式带精装修，想邀请您过来参观了解一下。',
              readStatus: 0
            }, {
              callKey: {
                sessionId: '1499eddebbf970a905a0094dba295afc',
                callerPhoneNum: '075995408207',
                calledPhoneNum: '18620058240'
              },
              startTime: 1595999068,
              endTime: 1595999093,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month7/000-2185202697-12368-2b274b6e074040ac9500fb032b27c4d1-000-1595999068.mp3',
              chatList: [{time: 1595999068, callerText: '', respText: '(自定义开场白录音)'}, {
                time: 1595999084,
                callerText: '喂，你好，我是保定销售中心打来的，我们在荔湾区长寿路商铺出售，如果您感兴趣的话可以了解一下。',
                respText: '诶，您好，有什么事可以告诉我，我帮您转达。'
              }, {time: 1595999091, callerText: '我把免费的。', respText: '嗯好，我已经记录下来，还有什么事？'}],
              calledCountOnWeek: 1,
              endTimeOnWeek: 1596508030,
              intention: '',
              refineInfo: '',
              startTimeText: '07月29日 13:04',
              endTimeText: '07月29日 13:04',
              firstMsg: '喂，你好，我是保定销售中心打来的，我们在荔湾区长寿路商铺出售，如果您感兴趣的话可以了解一下。',
              readStatus: 1
            }, {
              callKey: {
                sessionId: '6c7eadd12857af4005fab52d1aa3fe9d',
                callerPhoneNum: '15676679414',
                calledPhoneNum: '18620058240'
              },
              startTime: 1595730296,
              endTime: 1595730318,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month7/000-155094025-12368-981f229398254c23995d94304c6008f7-000-1595730296.mp3',
              chatList: [{time: 1595730296, callerText: '', respText: '(自定义开场白录音)'}, {
                time: 1595730306,
                callerText: '啊，有了解到，您在关注股票，这方面对吗。',
                respText: '是属于什么类型的理财产品呢？'
              }, {time: 1595730317, callerText: '那打扰您了，祝您生活愉快，投资顺利再见。', respText: '那么年利率是多少呢？'}],
              calledCountOnWeek: 6,
              endTimeOnWeek: 1595903230,
              intention: '',
              refineInfo: '',
              startTimeText: '07月26日 10:24',
              endTimeText: '07月26日 10:25',
              firstMsg: '啊，有了解到，您在关注股票，这方面对吗。',
              readStatus: 1
            }, {
              callKey: {
                sessionId: 'e7c9d7dcc87418cc1c06cbc405efe09c',
                callerPhoneNum: '02156296343',
                calledPhoneNum: '18620058240'
              },
              startTime: 1595382730,
              endTime: 1595382742,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month7/000-339708937-12363-26504a1657214482a43c203dd6bdbed1-000-1595382730.mp3',
              chatList: [{time: 1595382731, callerText: '', respText: '(自定义开场白录音)'}],
              calledCountOnWeek: 5,
              endTimeOnWeek: 1595903230,
              intention: '',
              refineInfo: '',
              startTimeText: '07月22日 09:52',
              endTimeText: '07月22日 09:52',
              firstMsg: '',
              readStatus: 1
            }, {
              callKey: {
                sessionId: 'da7aafb0625e9de44f91688881dfc9ba',
                callerPhoneNum: '075995408292',
                calledPhoneNum: '18620058240'
              },
              startTime: 1595323343,
              endTime: 1595323350,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month7/000-339708937-12363-90d2183558ee49c49123155fd9000a92-000-1595323343.mp3',
              chatList: [{time: 1595323344, callerText: '', respText: '(自定义开场白录音)'}],
              calledCountOnWeek: 4,
              endTimeOnWeek: 1595903230,
              intention: '',
              refineInfo: '',
              startTimeText: '07月21日 17:22',
              endTimeText: '07月21日 17:22',
              firstMsg: '',
              readStatus: 1
            }, {
              callKey: {
                sessionId: 'a8af8901a44f8e76a932e546cf439a25',
                callerPhoneNum: '02010108819',
                calledPhoneNum: '18620058240'
              },
              startTime: 1595316689,
              endTime: 1595316709,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month7/000-1883147273-12365-6aa1a431094a4b45979decc2a304918b-000-1595316688.mp3',
              chatList: [{time: 1595316689, callerText: '', respText: '(自定义开场白录音)'}],
              calledCountOnWeek: 3,
              endTimeOnWeek: 1595903230,
              intention: '',
              refineInfo: '',
              startTimeText: '07月21日 15:31',
              endTimeText: '07月21日 15:31',
              firstMsg: '',
              readStatus: 1
            }, {
              callKey: {
                sessionId: '24960c779d98eb24ec0ec67c535d717b',
                callerPhoneNum: '02081167888',
                calledPhoneNum: '18620058240'
              },
              startTime: 1595298454,
              endTime: 1595298458,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month7/000-3661532169-12367-f91a5eb6ce904ac998a01dd65a08942b-000-1595298454.mp3',
              chatList: [{time: 1595298454, callerText: '', respText: '(自定义开场白录音)'}],
              calledCountOnWeek: 2,
              endTimeOnWeek: 1595903230,
              intention: '',
              refineInfo: '',
              startTimeText: '07月21日 10:27',
              endTimeText: '07月21日 10:27',
              firstMsg: '',
              readStatus: 1
            }, {
              callKey: {
                sessionId: '57bfa230c234eb80c8ef077cfd6b0098',
                callerPhoneNum: '02081167888',
                calledPhoneNum: '18620058240'
              },
              startTime: 1595298430,
              endTime: 1595298439,
              recordUrl: 'http://recorder-10018504.cos.ap-shanghai.myqcloud.com/def/month7/000-591301641-12363-fde3b21e9a744a46b2578fe033f4aff3-000-1595298430.mp3',
              chatList: [{time: 1595298431, callerText: '', respText: '喂，您好，我是机主的助理，请问您是哪位？'}],
              calledCountOnWeek: 1,
              endTimeOnWeek: 1595903230,
              intention: '',
              refineInfo: '',
              startTimeText: '07月21日 10:27',
              endTimeText: '07月21日 10:27',
              firstMsg: '',
              readStatus: 1
            }],
            'totalRecord': 16,
            'totalTime': 260
          },
          'requestData': {
            'fin': {
              'apn': 2,
              'authType': 0,
              'guid': '',
              'ext1': '',
              sessionId: '',
              'buildno': 0,
              'netType': 0,
              'accountId': '133982088914622752',
              'bootType': 0,
              'wsGuid': ''
            },
            'req': {startTime: 1600936013, 'phoneNum': '18620058240', 'platformType': 3}
          }
        }
      }
      resolve(data.data.resp)
    })
  } else {
    return new Promise((resolve, reject) => {
      _authReq({
        name: 'getCalledList',
        method: 'post',
        data: {
          startTime: startTime,
          phoneNum: app.getData().userSetting.phoneNum
        }
      }).then(res => {
        if (res.data.success) {
          // console.log("getCalledList " + JSON.stringify(res.data))
          resolve(res.data.data.resp)
        } else {
          console.log('getCalledList empty')
          resolve({
            isFinished: true,
            recordList: [],
            result: 0,
            totalRecord: 0,
            totalTime: 0,
          })
        }
      })
    })
  }
}

// 绑定成功以后，后台返回呼叫转移号码
function getCallForwardNum () {
  return new Promise((resolve, reject) => {
    resolve('02088888888')
  })
}

// 绑定手机号码
function bindPhone (phoneNum, verifyCode) {
  return new Promise((resolve, reject) => {
    _authReq({
      name: 'bindPhone',
      method: 'post',
      data: {
        phoneNum,
        verifyCode
      }
    }).then(res => {
      console.log('bindPhone', res, JSON.stringify(res.data.data))
      if (res.data.code === 0 && res.data.data.resp.retCode === 0) {
        resolve(0)
      } else {
        reject(1)
      }
    }).catch(err => {
      console.log('bindPhone', 'err', err)
      reject(0)
    })
  })
}

function reportCallRead (sessionId) {
  return new Promise((resolve, reject) => {
    wx.lb.request({
      name: 'reportCallRead',
      method: 'post',
      data: {
        sessionId
      }
    }).then(res => {
      console.log('reportCallRead', res, JSON.stringify(res.data.data))
      resolve(0)
    }).catch(err => {
      console.log('reportCallRead', err)
      reject(err)
    })
  })
}

function reportProfile () {
  return _authReq({
    name: 'reportProfile',
    method: 'post',
    data: {
      settingData: app.getData().userSetting
    }
  })
}

function getOpeningRemark () {
  return _authReq({
    name: 'getUserOpeningRemark',
    method: 'post',
    data: {
      phone: app.getData().userSetting.phoneNum
    }
  })
}

function reportCustomContent (userStatus, firstTalk, callName) {
  return _authReq({
    name: 'reportCustomContent',
    method: 'post',
    data: {
      phone: app.getData().userSetting.phoneNum,
      userStatus,
      firstTalk,
      callName
    }
  })
}

function getTagPhonenum (nums) {
  return wx.lb.request({
    name: 'getTagPhonenum',
    method: 'post',
    data: {
      nums: nums
    }
  })
}

function sendPhoneCode (num) {
  return _authReq({
    name: 'sendPhoneCode',
    method: 'post',
    data: {
      phone: num
    }
  })
}

function fetchSceneReplyData (num) {
  return _authReq({
    name: 'fetchSceneReplyData',
    method: 'post',
    data: {
      phone: num
    }
  })
}

function updateSceneReply (num, sceneCustomizeScriptMap) {
  return _authReq({
    name: 'updateSceneReply',
    method: 'post',
    data: {
      phone: num,
      sceneCustomizeScriptMap: sceneCustomizeScriptMap
    }
  })
}

function getVipInfoWithLimit () {
  return wx.lb.request({
    name: 'getVipLimit',
    method: 'post'
  })
}

function updateVipLimit () {
  return wx.lb.request({
    name: 'setVipLimit',
    method: 'post'
  })
}

/**
 * 封装鲁班请求接口，必须附带小票据actToken
 * @param req
 * @returns {Promise<unknown>}
 * @private
 */
async function _authReq (req) {
  let token = app.getData().token
  let gid = app.getData().accountId

  return new Promise((resolve, reject) => {
    if (token) {
      req.data = Object.assign(req.data || {}, {token, gid})
      console.log('auth', req)
      wx.lb.request(req)
        .then(resolve)
        .catch(reject)
    } else {
      reject(new Error(`token err: ${token}`))
    }
  })
}

// 先悉统计点上报
function reportseer (event, data1, data2, data3) {
  return wx.lb.request({
    name: 'reportseer',
    method: 'post',
    data: {
      event,
      data1,
      data2,
      data3,
      data4: 'qqpim',
      data5: app.getData().platform
    }
  })
}

// 客户端需要实现的js接口
export default {
  getUserSetting,
  getCalledList,
  getCallForwardNum,
  bindPhone,
  reportCallRead,
  reportProfile,
  getOpeningRemark,
  reportCustomContent,
  sendPhoneCode,
  fetchSceneReplyData,
  updateSceneReply,
  getVipInfoWithLimit,
  updateVipLimit,
  getTagPhonenum,
  reportseer,
  _authReq
}



// WEBPACK FOOTER //
// ./src/lubanApi.js